import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
//import '../../css/CreateCustomer.css';
import Vas from '../../Vas';

import CaptchaBox from '../../custom_controls/CaptchaBox';

import { DateTimeHelper,CheckValues,Jump,SetRequired,CheckFields } from 'utils-lib';

import { TextField, SelectField,DateField,ExtendedButton,MessageBox,Checkbox,AutocompleteField,Loading,EmailField } from 'component-lib';

import { RequestAjaxClass, AccountsModel,StreetsModel,CustomerModel} from 'models-lib';
var moment = require('moment');
moment().format();

class CreateCustomers  extends Component {
    
    constructor(props)
    {
        super(props);
        this.state = {};

        this.state.steps = 2;
        
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
        this.AccountsModel = new AccountsModel([this],null,this.Request);
        this.StreetsModel = new StreetsModel([this],null,this.Request);
        this.CustomerModel = new CustomerModel([this],null,this.Request);
    }
    
    /**
     * updates the state object
     * @constructor
     */
    componentDidMount()
    {
        this.Request.setApiUrl(Vas.ApiUrl);
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setAuth(true);

        this.jump(1);
      
        this.AccountsModel.Own();

        let reqFields = [{Key:this.refs.name,Index:1,Step:1}, 
                        {Key:this.refs.firstName,Index:2,Step:1}, 
                        {Key:this.refs.dateOfBirth,Index:4,Step:1}, 
                        {Key:this.refs.street,Index:5,Step:1}, 
                        {Key:this.refs.houseNumber,Index:6,Step:1}, 
                        {Key:this.refs.zip,Index:7,Step:1}, 
                        {Key:this.refs.place,Index:8,Step:1}];

        let reqCheckBox = [];
        if (Vas.Captcha === true){
          reqCheckBox.push({Key:this.refs.captcha,Index:9,Step:2});
        }

        this.setState({ requiredFields:reqFields,
            requiredSelectField:[{Key:this.refs.Gender,Index:3,Step:1}],
            requiredCheckBox : reqCheckBox },()=>{
              SetRequired.Set(this.state.requiredFields,this.state.requiredSelectField,this.state.requiredCheckBox);
            });
    }

    Update(observer)
    {
        let me =this;
        this.setState({},()=>{
          if(observer === "AccountsOwn"){
            if (me.AccountsModel.Customer){
              me.CustomerModel.Customer.ClientId = me.AccountsModel.Customer.ClientId;
            }
          }else if(observer === "Streets"){
            me.refs.street.setState({ Data: me.StreetsModel.Streets, Icon :'',placeholder:'' });
          }else if(observer === "InsertCustomer"){
            Vas.GetView("CreateCustomerSuccess",null,true);
          }
        });
    }

    Create(){

        let filled = this.checkFields();
        if (filled === true){

            ReactDOM.render(<Loading modal={true} />,document.getElementById('messageContainer'));
            
            this.CustomerModel.InsertCustomer();
        }
    }

    jumpTofirst(first,id){
      Jump.jump(this.state.steps,id,null,null,first);
      
    }

    checkFields(){
        
        if (this.state.requiredFields && this.state.requiredSelectField ){
          let all = CheckFields.CheckFields(this.state.requiredFields,this.state.requiredSelectField,this.state.requiredCheckBox);
               
          if (all[0] === false){
            let docs=document.querySelectorAll('select,input');
            let docRefs = this.refs;
            CheckValues.checkAllFields(docs,docRefs,"");
            ReactDOM.render(<MessageBox 
              Message={Vas.Resources.Labels["NotAllFields"]} 
              Title={Vas.Resources.Titles["Note"]}
              Click={()=>{
                this.jumpTofirst(all[1],1); 
              }}
              />,
                            document.getElementById('messageContainer'));
            return false;
          } else {
            return true;
          }
         }        
    }

    getStreets()
    {
        let me = this;
        if (this.CustomerModel.Customer.City && this.CustomerModel.Customer.PostCode){
           this.StreetsModel.GetStreets(this.CustomerModel.Customer.City,this.CustomerModel.Customer.PostCode);
            me.refs.street.setState({ Icon:"Loop" });
        }
    }

    jump(id)//springe zu einem anderen Stepperfeld
    {
      Jump.jump(this.state.steps,id);
    }

    //#region steps
    buildStepperTable(number,title,content,buttonContinue,buttonBack,buttonOrder,buttonChange,buttonCreate){
      let btoContinue = '';
      if (buttonContinue === true){
        btoContinue = (<ExtendedButton
          Id={"buttonContinue"}
          Usable={true}
          Text={Vas.Resources.Labels["Continue"]}
          Float={"left"}
          Width={180}
          OnClick={() => { this.jump((number +1), number.toString()); }} />);
      }

      let btoBack = '';
      if (buttonBack === true){
        btoBack = (<ExtendedButton
          Id={"buttonBack"}
          Usable={true}
          Text={Vas.Resources.Labels["Back"]}
          Width={180}
          Float={"left"}
          OnClick={() => { this.jump((number -1), number.toString()); }} />);
      }

      let btoOrder = '';
      if (buttonOrder === true){
        btoOrder = (<ExtendedButton 
          ref={"Order"}
          Usable={true} 
          Text={Vas.Resources.Labels["OrderCosts"]} 
          OnClick={()=>{ this.Order();}} 
          Float={"left"} 
          Width={180} 
          Id={"btoOrder"} />);
      }

      let btoChange = '';
      if(buttonChange === true){
        btoChange = (
          <ExtendedButton 
              ref={"Order"} 
              Usable={true} 
              Text={Vas.Resources.Labels["ChangeCosts"]} 
              OnClick={()=>{ this.Order();}} 
              Float={"left"} 
              Width={180} 
              Id={"btoOrder"} />
        );
      }

      let btoCreate = '';
      if(buttonCreate === true){
        btoCreate = (
          <ExtendedButton 
              ref={"Create"} 
              Usable={true} 
              Text={Vas.Resources.Labels["Create"]} 
              OnClick={()=>{ this.Create();}} 
              Float={"left"} 
              Width={180} 
              Id={"btoCreate"} />
        );
      }

      return (<table
        id={"StepperTable_" +title}
        className={"StepperTable"}>
        <tbody>
          <tr onClick={() => { this.jump(number.toString()); }}>
            <td><div
              id={"i" + number.toString()}
              className={"StepperIcon"} >{number}</div></td>
            <td><div className={"StepperLabel"}>{title}</div></td>
          </tr>
          <tr
            id={number.toString()}
            className={"c"} 
            style={{ display: 'none' }}>
            <td className={"StepperConnector"}></td>
            <td>
              {content}
              <br />
              {btoBack}
              {btoContinue}
              {btoOrder}
              {btoChange}
              {btoCreate}
            </td>
          </tr>
        </tbody>
      </table>);
    }

    setStepperPersonalData(){
      //hier das Maxdatum setzen (Heute - 18 Jahre)
        //Bsp.: Heute: 07.01.2019 -> Max Geburtsdatum 07.01.2001
        let max = moment();
        //let maxValue = moment([max.year() - 18, max.month(), max.date()]);
        let maxValue = max;
      return(
        <table>
          <tbody>
            <tr>
              <td>
                <TextField
                  Modus={"Name"}
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  Id={"name"}
                  ref={"name"}
                  IsRequired={true}
                  Editable={true}
                  name="name"
                  Label={Vas.Resources.Labels["Name"]}
                  Tooltip={Vas.Resources.Tooltips["Name"]}
                  OnBlur={()=>{ this.CustomerModel.Customer.Name1 = $("#name").val() }}  />
              </td>
              <td>
                <TextField
                  Modus={"Name"}
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  Id={"firstname"}
                  ref={"firstName"}
                  IsRequired={true}
                  Editable={true}
                  name="firstName"
                  Label={Vas.Resources.Labels["FirstName"]}
                  Tooltip={Vas.Resources.Tooltips["Firstname"]}
                  OnBlur={()=>{ this.CustomerModel.Customer.Name2 = $("#firstname").val();}}  />
              </td>
            </tr>
            <tr>
              <td>
                <SelectField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"Gender"}
                  Id={"Gender"}
                  IsRequired={true}
                  Label={Vas.Resources.Labels["Gender"]}
                  Data={[{ Key: 'Männlich', Display: Vas.Resources.Labels["Male"] },{ Key: 'Weiblich', Display: Vas.Resources.Labels["Female"] }]}
                  OnChange={()=>{ this.CustomerModel.Customer.Gender =  $("#Gender").val() ;}}
                  Tooltip={Vas.Resources.Tooltips["Gender"]} />
              </td>
              <td>
                <DateField
                  AppURL={Vas.ApplicationUrl}
                  MaxValue={maxValue}
                  me={this}
                  Editable={true} 
                  ref={"dateOfBirth"}
                  IsRequired={true}
                  Id={"DateOfBirth"}
                  Tooltip={Vas.Resources.Tooltips["DateOfBirth"]}
                  Label={Vas.Resources.Labels["DateOfBirth"]} 
                  OnBlur={()=>{
                    let cur = DateTimeHelper.StringToDate($("#DateOfBirth").val(),false,localStorage.getItem('vas_language'));
                    this.CustomerModel.Customer.DateOfBirth = moment([cur.year(),cur.month(),cur.date()]).format("YYYY-MM-DD T 00:00:00");
                  }}  
                  Language={localStorage.getItem("vas_language")}
                  FalseMaxDateText={Vas.Resources.Labels["CustomerOfAge"]} />
              </td>
            </tr>
            
            <tr>
              <td>
                <TextField
                  me={this}
                  Editable={true}
                  IsRequired={true}
                  ref={"zip"}
                  Id={"zip"}
                  name="zip"
                  Tooltip={Vas.Resources.Tooltips["Zip"]}
                  Label={Vas.Resources.Labels["Zip"]}
                  OnBlur={()=>{this.CustomerModel.Customer.PostCode =  $("#zip").val() ;}} />
              </td>
              <td>
                <TextField
                  me={this}
                  Editable={true}
                  IsRequired={true}
                  ref={"place"}
                  Id={"place"}
                  name="place"
                  Tooltip={Vas.Resources.Tooltips["Place"]}
                  Label={Vas.Resources.Labels["Place"]}
                  OnBlur={()=>{this.CustomerModel.Customer.City = $("#place").val() ; this.getStreets();}} />
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <AutocompleteField
                  AppURL={Vas.ApplicationUrl}
                  TitleMessageFalseStreet={Vas.Resources.Labels["Error"]}
                  MessageFalseStreet={Vas.Resources.Labels["FalseStreet"]}
                  Modus={"Street"}
                  ref={"street"}
                  Id={"Street"}
                  Float={'left'}
                  IsRequired={true}
                  editable={true}
                  Label={Vas.Resources.Labels["Street"]}
                  Data={this.state.streets}
                  OnBlur={()=>{this.CustomerModel.Customer.Street = $("#Street").val() ; }}
                  Tooltip={Vas.Resources.Tooltips["Street"]}
                  TimeOutTime={Vas.TimeOutTime}
                  Width={365} />
              </td>
              
            </tr>
            <tr>
              <td>
                <TextField
                  me={this}
                  Editable={true}
                  IsRequired={true}
                  ref={"houseNumber"}
                  Id={"houseNumber"}
                  name="houseNumber"
                  Tooltip={Vas.Resources.Tooltips["Housenumber"]}
                  Label={Vas.Resources.Labels["HouseNumber"]}
                  OnBlur={()=>{this.CustomerModel.Customer.HouseNumber = $("#houseNumber").val() ;}} />
              </td>
              <td>
                <TextField
                  me={this}
                  Id="houseNumberAddition"
                  Editable={true}
                  IsRequired={false}
                  Tooltip={Vas.Resources.Tooltips["HouseNumberAddition"]}
                  Label={Vas.Resources.Labels["HouseNumberAddition"]}
                  OnBlur={()=>{this.CustomerModel.Customer.HouseNumberAddition = $("#houseNumberAddition").val() ; }} />
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <TextField
                  Id="addressAddition"
                  Editable={true}
                  IsRequired={false}
                  Tooltip={Vas.Resources.Tooltips["AddressAddition"]}
                  Label={Vas.Resources.Labels["AddressAddition"]}
                  OnBlur={()=>{ this.CustomerModel.Customer.Name3 = $("#addressAddition").val() ; }}
                  Width={365} />
              </td>
              
            </tr>
            <tr>
              <td colSpan={2}>
                <EmailField
                  ApiUrl={Vas.ApiUrl}
                  ApiKey={Vas.ApiKey}
                  Token={localStorage.getItem["vas_token"]}
                  AnonymousToken={localStorage.getItem["anonymous_token"]}
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  Id="email"
                  ref={"email"}
                  Editable={true}
                  IsRequired={false}
                  Tooltip={Vas.Resources.Tooltips["Email"]}
                  Label={Vas.Resources.Labels["Email"]}
                  OnBlur={()=>{
                    if (this.refs.email.getValid() === true){
                      this.CustomerModel.Customer.Email = $("#email").val();
                    } else {
                      $('#email').val('');
                      this.CustomerModel.Customer.Email = '' ;
                    }
                  }} 
                  Width={350}/>
              </td>
            </tr>
            <tr>
              <td>
                <TextField
                  me={this}
                  Id="phone"
                  Editable={true}
                  IsRequired={false}
                  Tooltip={Vas.Resources.Tooltips["Phone"]}
                  Label={Vas.Resources.Labels["Phone"]}
                  OnBlur={()=>{this.CustomerModel.Customer.Phone = $("#phone").val() ; }} />
              </td>
              <td>
                
              </td>
            </tr>
            <tr>
              <td>{Vas.Resources.Labels["RequiredField"]}</td>
            </tr>
          </tbody>
        </table>
      )
    }

    setStepperCreate(){
      
      return(
        <table>
          <tbody>
            <tr>
              <td>
                <CaptchaBox
                  Id={"Captcha"}
                  IsRequired={Vas.Captcha}
                  ref={"captcha"}
                />
                <br/>
              </td>
            </tr>
            <tr>
              <td style={{paddingLeft:'4px'}}>
                <Checkbox
                  ref={"MarketingEmail"}
                  Id={"checkboxMarketingEmail"}
                  onClick={()=>{this.CustomerModel.Customer.MarketingEmail = document.getElementById("checkboxMarketingEmail").checked ;}}
                  IsRequired={false} />
                <div>
                  <div >
                    {Vas.Resources.Labels["MarketingComplienceMail"]}
                  </div>
                </div>
              </td>                            
            </tr>
            <tr>
              <td style={{paddingLeft:'4px'}}>
                <Checkbox
                  ref={"MarketingPhone"}
                  Id={"ceckboxMarketingPhone"}
                  onClick={()=>{this.CustomerModel.Customer.MarketingPhone = document.getElementById("ceckboxMarketingPhone").checked ;}}
                  IsRequired={false} />
                <div>
                  <div >
                    {Vas.Resources.Labels["MarketingCompliencePhone"]}
                  </div>
                </div>
              </td>                            
            </tr>
            <tr>
              <td style={{paddingLeft:'4px'}}>
                <Checkbox
                  ref={"MarketingPost"}
                  Id={"ceckboxMarketingPost"}
                  onClick={()=>{this.CustomerModel.Customer.MarketingPost = document.getElementById("ceckboxMarketingPost").checked ;}}
                  IsRequired={false} />
                <div>
                  <div >
                    {Vas.Resources.Labels["MarketingCompliencePost"]}
                  </div>
                </div>
                <br/>
              </td>                            
            </tr>
            <tr>
              <td>{Vas.Resources.Labels["RequiredField"]}</td>
            </tr>
            
          </tbody>
        </table>
      )
    }

    //#endregion
    render()
    {
        let personal = this.buildStepperTable(1,Vas.Resources.Labels["PersonalData"],this.setStepperPersonalData(),true);
        let order = this.buildStepperTable(2,Vas.Resources.Labels["CreateCustomer"],this.setStepperCreate(),false,true,false,false,true);

        

        return (
          <div className={"form"} style={{width:'800px'}}>
            <table style={{ width:'100%' }}>
              <thead>
                <tr>
                  <th>
                  <h2>{Vas.Resources.Labels["CreateCustomer"]}</h2>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{textAlign:'justify'}}>
                    {personal}
                    {order}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        );
    }
}
export default CreateCustomers;
